var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMapOptions = function SvgMapOptions(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7625 16.35L4.25 19.5V6.9L9.7625 3.75M9.7625 16.35L15.275 19.5M9.7625 16.35V3.75M15.275 19.5L20 16.35V3.75L15.275 6.9M15.275 19.5V6.9M15.275 6.9L9.7625 3.75",
    stroke: "#5547DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9471 13.3026L17.9668 12.5H16.0329L15.0525 13.3029L14.9648 13.7391L14.5354 13.5947L13.3518 14.0404L12.3852 15.7054L12.5921 16.9606L12.9234 17.25L12.5921 17.5394L12.3852 18.7947L13.3522 20.4597L14.5356 20.9054L14.9648 20.7611L15.0525 21.1971L16.0329 22H17.9668L18.9472 21.1971L19.0349 20.7609L19.4642 20.9053L20.6478 20.4597L21.6147 18.7947L21.4078 17.5393L21.0764 17.2499L21.4076 16.9606L21.6144 15.7053L20.6475 14.0403L19.464 13.5947L19.035 13.7389L18.9471 13.3026ZM16.9998 17.6136C16.8994 17.6136 16.8043 17.5739 16.735 17.5051C16.666 17.4364 16.6283 17.3446 16.6283 17.25C16.6283 17.1554 16.666 17.0636 16.735 16.9949L16.03 16.2858L16.7351 16.9949C16.8043 16.9261 16.8994 16.8864 16.9998 16.8864C17.1002 16.8864 17.1954 16.9261 17.2646 16.9949C17.3337 17.0636 17.3714 17.1554 17.3714 17.25C17.3714 17.3446 17.3337 17.4364 17.2646 17.5051C17.1954 17.5739 17.1002 17.6136 16.9998 17.6136Z",
    fill: "#5547DD",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMapOptions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Map Options.5717b99ddb98129db8da1c86aab43f7a.svg";